var map = {
	"./00001-regenerateFriendsKeys": "ym3/",
	"./00001-regenerateFriendsKeys.js": "ym3/",
	"./00002-fixBrokenSettings": "5sYn",
	"./00002-fixBrokenSettings.js": "5sYn",
	"./migrationExample": "eahS",
	"./migrationExample.js": "eahS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "K6VQ";


//////////////////
// WEBPACK FOOTER
// ./js/migrations ^\.\/.*$
// module id = K6VQ
// module chunks = 1 2 3